import { inject, Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class VersionService {
  private meta = inject(Meta);

  async apply() {
    if (location.hostname === 'localhost') {
      return;
    }

    try {
      const file = await fetch('VERSION.json');
      const { version } = await file.json();

      this.meta.addTags([{ content: version, name: 'version' }]);
    } catch {
      this.meta.addTags([{ content: 'development', name: 'version' }]);
    }
  }
}
